import { inject, observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Alert } from 'reactstrap';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import UIStore from '../../../store/UIStore';

const TimerMessage = ({ configStore, uiStore }) => {
  const { globalUserMessageData } = uiStore;

  const getContent = () => {
    if (globalUserMessageData.isTranslatable) {
      return <FormattedMessage {...globalUserMessageData} />;
    }

    return globalUserMessageData.defaultMessage;
  };

  const renderContent = () => {
    return (
      <Alert className="TimerMessage App__alert" color='danger' isOpen={globalUserMessageData.isOpen && globalUserMessageData.hasContent}>
        <h4 className='alert-heading'>{configStore.store.name}</h4>
        {getContent()}
      </Alert>
    );
  };

  return renderContent();
};

TimerMessage.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  uiStore: modelOf(UIStore).isRequired,
};

export default inject('configStore', 'uiStore')(observer(TimerMessage));
